export function externalLink() {
    document.addEventListener('DOMContentLoaded', () => {
        const articleLinks = document.querySelectorAll(`#content-single a[href^="http"]:not([href*="${window.location.host}"]),
      #comments a[href^="http"]:not([href*="${window.location.host}"])`);
        if (!articleLinks)
            return false;
        articleLinks.forEach(function (link) {
            link.setAttribute('target', '_blank');
            link.setAttribute('rel', 'noopener noreferrer');
        });
    });
}
//# sourceMappingURL=external-links.js.map